import React from 'react';
import { useAuth } from '../hooks/useAuth';

export default function ProtectedRoute({ children, isAdminRequired = false }) {
  const { user, isAdmin } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center text-white text-xs">
        Bạn cần đăng nhập để truy cập trang này.
      </div>
    );
  }

  if (isAdminRequired && !isAdmin) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center text-rose-500 text-xs font-bold">
        Bạn không có quyền truy cập trang quản trị!
      </div>
    );
  }

  return children;
}